var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-subheader',[_vm._v(" devices "),_c('v-spacer'),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.remove}},[_c('v-icon',[_vm._v("mdi-delete")])],1)],1),_c('v-divider'),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items},scopedSlots:_vm._u([{key:"item.createdAt",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.createdAt.toLocaleString())+" ")]}},{key:"item.lastSecond.time",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.lastSecond.time.toLocaleString())+" ")]}},{key:"item.id",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"text":""}},[_vm._v(" "+_vm._s(item.id)+" ")])]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }